// Wraps routes that require a valid token. If no token at all → redirect.
// Real validation (token expired, etc.) happens lazily on the first API call,
// which throws 401 → api.ts redirects to /auth/login.

import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getToken } from '../lib/auth';

export function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  if (!getToken()) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/auth/login?redirect=${next}`} replace />;
  }
  return <>{children}</>;
}
